import { getSearchFinancialInstitutionsState } from './../../../shared/shared.select'
import { SearchFinancialInstitutionRequest } from './../../../shared/shared.actions'
import { debounceTime } from 'rxjs/operators'
import { getFinancialInstitutionsState } from './../../financial-institutions/financial-institutions.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { getRoles, getCreateUserState } from './../users.selectors'
import {
  FetchRolesRequest,
  UpdateField,
  CreateUserRequest,
  SetDefaultData,
} from './../users.actions'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription, Subject } from 'rxjs'
import { FetchFinancialInstitutionsRequest } from '@containers/financial-institutions/financial-institutions.actions'

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css'],
})
export class CreateUserComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public roles: any[]
  private state$: Subscription
  private rolesState$: Subscription
  public isLoading: boolean
  public financialInstitutions: any[]
  public onFinancialInstitutionAutocomplete$ = new Subject<string>()
  private financialInstitutionAutocomplete$: Subscription
  private searchFinancialInstitutionState$: Subscription

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createUser'))

    this.rolesState$ = this.store.pipe(select(getRoles)).subscribe((roles) => {
      this.roles = roles.toJS()
    })

    this.searchFinancialInstitutionState$ = this.store
      .pipe(select(getSearchFinancialInstitutionsState))
      .subscribe((financialInstitutions) => {
        this.financialInstitutions = financialInstitutions.get('data').toJS()
      })

    this.state$ = this.store
      .pipe(select(getCreateUserState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.financialInstitutionAutocomplete$ =
      this.onFinancialInstitutionAutocomplete$
        .pipe(debounceTime(500))
        .subscribe((keyword: string | null) => {
          this.store.dispatch<any>(
            new SearchFinancialInstitutionRequest(keyword ? keyword : ''),
          )
        })

    this.store.dispatch<any>(new FetchRolesRequest())
    this.store.dispatch<any>(new SearchFinancialInstitutionRequest(''))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.rolesState$.unsubscribe()
    this.searchFinancialInstitutionState$.unsubscribe()
    this.financialInstitutionAutocomplete$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createUser.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createUser',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      firstName: 'required',
      lastName: 'required',
      email: 'required|email',
      roles: 'required|array',
      password: 'required',
    }
    const validator = new Validator(
      {
        firstName: data.get('firstName'),
        lastName: data.get('lastName'),
        email: data.get('email'),
        roles: data.get('roles') ? data.get('roles').toJS() : [],
        password: data.get('password'),
      },
      rules,
    )

    validator.setAttributeNames({
      firstName: 'first name',
      lastName: 'last name',
      financialInstitutionId: 'financial institution',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state
      .get('data')
      .set(
        'roles',
        (this.state.getIn(['data', 'roles']) as any[]).map((r: any) =>
          r.get('name'),
        ),
      )
      .toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateUserRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createUser',
        ),
      )
    }
  }
}
